import React from "react";
import Paper from "material-ui/Paper";
import markdown from "markdown-it";
import mathjax from "markdown-it-mathjax";
const md = markdown().use(mathjax());
class Documentation extends React.PureComponent {
  state = { documentation: "" };

  componentDidMount() {
    fetch("/documentation.md").then(res => {
      res.text().then(data => this.setState({ documentation: data }));
    });
    if (window.MathJax) {
      window.MathJax.Hub.Queue(["Typeset", MathJax.Hub]); // eslint-disable-line no-undef
    }
  }

  componentDidUpdate() {
    if (window.MathJax) {
      window.MathJax.Hub.Queue(["Typeset", MathJax.Hub]); // eslint-disable-line no-undef
    }
  }

  render() {
    return (
      <Paper className={"paper-container documentation"}>
        {/* <ReactMarkdown source={this.state.documentation} /> */}
        <div
          dangerouslySetInnerHTML={{
            __html: md.render(this.state.documentation)
          }}
        />
      </Paper>
    );
  }
}

export default Documentation;



// WEBPACK FOOTER //
// ./src/pages/documentation.js